import { useEffect, useState } from "react";
import ModalTemplate from "../../../components/modal/modalTemplate";
import { fetchJobStatusHistory } from "../service";
import { formatDateInJobStatsLog } from "../../../utils";
import DivSpinner from "../../../components/divSpinner";

const JobStatusChangeLogs = ({ job_id, show, handleClose }) => {
    const [loading, setLoading] = useState(true);
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        const getJobStatusHistory = async () => {
            try {
                setLoading(true);
                const response = await fetchJobStatusHistory(job_id);
                if (response.status === "Success") {
                    setLogs(response.job_status_history)
                }
            } catch (err) {
                console.log("🚀 ~ getJobStatusHistory ~ err:", err);
            } finally {
                setLoading(false);
            }
        }

        getJobStatusHistory();
    }, [job_id]);

    const LoadingComponent = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            centered
            title={"Job status change logs"}
            body={
                <div className="card">
                    <div className="card-body">
                        {loading ? (
                            <LoadingComponent />
                        ) : (
                            <div className="timeline timeline-one-side">
                                {logs.map((log, index) => (
                                    <div className="timeline-block mb-3" key={index}>
                                        <span className="timeline-step p-3" style={{ backgroundColor: log.job_status?.job_status_color }}>
                                            <i className="material-icons text-white text-sm opacity-10">
                                                {log.job_status?.job_status_icon}
                                            </i>
                                        </span>
                                        <div className="timeline-content pt-1">
                                            <h6 className="text-dark text-sm font-weight-bold mb-0">{log.job_status?.job_status_name}</h6>
                                            <p className="text-secondary text-xs mt-1 mb-0">{formatDateInJobStatsLog(log?.job_status_change_log_timestamp)}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            }
            footer={<></>}
        />
    );
};

export default JobStatusChangeLogs;